import { getEnvVar } from '../utils/env';

export const HOME = '/';

export const ENTITY_DISPLAY = '/entity-display';
export const WORKFLOW_STEP = '/workflow-step';
export const DOCUMENT_REPOSITORY = '/document-repository';
export const PRODUCT_HIERARCHY = '/hierarchy';
export const DOCUMENT_VIEWER = '/document-content-viewer';
export const DOCUMENT_COLLABORATION = '/document-collaboration';
export const DOCUMENT_COMPARE = '/document-compare';
export const MAIN_DASHBOARD = '/dashboard/main-dashboard';
export const FIND_PAGE = '/find';
export const MASTER_SETUP_PAGE = '/master-setup';
export const WORKFLOW_MASTER_SETUP_PAGE = '/workflow-master-setup';
export const QUEUE_SETUP_PAGE = '/monitoring-queue';
export const WORKFLOW_QUEUE_SETUP_PAGE = '/workflow-monitoring-queue';
export const SEARCH_PAGE = '/search';
export const ENHANCED_SEARCH_PAGE = '/enhanced-search';
export const FILE_DOWNLOAD = '/file-download';
export const CERTIFICATION_PAGE = '/certification';
export const CALENDAR_PAGE = '/calendar';
export const PAGE_CLOSE = '/close';
export const UPGRADE_MODULES_PAGE = '/upgrade-modules';
export const CACHE_LIST = '/cache-list';
export const FORMS_LIST = '/forms-list';
export const ENTITIES_LIST = '/entities-list';
export const ENTITY_DETAILS = '/entity-details';
export const REPORT_MODEL_DESIGNER = '/report-model-designer';
export const REPOSITORY_CONFIGURATION = '/repository-configuration';
export const REPOSITORY_LIST = '/repository-list';

export const HELP = `${getEnvVar('REACT_APP_ADMIN_APP_URL')}/Help/index.htm`;
export const TECHNICAL_SUPPORT = 'https://www.customerservice.iqvia.com/support/s/';
export const IQVIA = 'https://www.iqvia.com/';

export const LOGIN = '/login';
export const LOGOUT = '/logout';

export const FORM_EDITOR = '/form-editor';
export const ENTITY_EDITOR = '/entity-editor';
export const BULK_EDIT_PAGE = '/bulk-edit';
export const TRAININGS = '/trainings';
export const REPORT_DESIGNER = '/report-editor';
export const SAVED_SEARCH_EDITOR = '/saved-search-editor';

export const NEW_MASTER_SETUP_PAGE = '/new-master-setup';
export const NEW_WORKFLOW_STEP = '/new-workflow-step';
export const NEW_ENTITY_DISPLAY = '/new-entity-display';

export const SMART_INSIGHT = '/smart-insight';
export const SMART_INSIGHT_SAVED_SEARCHES = '/smart-insight?smartInsightType=savedSearches';
export const SMART_INSIGHT_REPORTS = '/smart-insight?smartInsightType=reports';
export const SMART_INSIGHT_REPORT_MODELS = '/smart-insight?smartInsightType=reportModels';
export const SMART_INSIGHT_REPORTS_LIST = '/smart-insight-reports';

export const POWERBI_REPORT_PAGE = '/powerbi-report';
export const POWERBI_REPORTS_PAGE = '/powerbi-reports';
export const POWERBI_EDITOR_PAGE = '/powerbi-editor';

export const APP_MIGRATION_PAGE = '/application-migration';

export const CONFIGURE_DATA_SOURCE = '/configure-datasources';
